/**
 * @prettier
 */

export const UiLogEventTypes = Object.freeze({
    USER_OPENED_PAGE: 'USER_OPENED_PAGE',
    USER_CLICKED_BUTTON: 'USER_CLICKED_BUTTON',
    USER_CLICKED_TAB: 'USER_CLICKED_TAB',
    USER_OPENED_DIALOG: 'USER_OPENED_DIALOG',
    USER_OPENED_CONTEXTUAL_MENU: 'USER_OPENED_CONTEXTUAL_MENU',
    USER_CLICKED_CONTEXTUAL_MENU_ITEM: 'USER_CLICKED_CONTEXTUAL_MENU_ITEM',
    USER_TOGGLED_ACCORDION: 'USER_TOGGLED_ACCORDION',
    USER_OPENED_ALERT_DIALOG: 'USER_OPENED_ALERT_DIALOG',
    USER_TYPED_INPUT: 'USER_TYPED_INPUT',
    USER_CLICKED_SWITCH: 'USER_CLICKED_SWITCH',
    USER_CLICKED_SELECT_OPTION: 'USER_CLICKED_SELECT_OPTION',
    USER_CLICKED_CHECKBOX: 'USER_CLICKED_CHECKBOX',
    USER_CLICKED_TABLE: 'USER_CLICKED_TABLE',
});

export type UiLogEventType = (typeof UiLogEventTypes)[keyof typeof UiLogEventTypes];
